const REACT_APP_API_URL = process.env.REACT_APP_API_URL;

// Helper function to get token
const getAuthToken = () => {
  return localStorage.getItem('token');
};

export const fetchBusinessProfiles = async (page = 1, limit = 20, search = '') => {
  try {
    const token = getAuthToken();
    const params = new URLSearchParams({
      limit: limit.toString(),
      offset: ((page - 1) * limit).toString(),
      search
    });
    
    const response = await fetch(`${REACT_APP_API_URL}/business/business-profiles?${params}`, {
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json'
      }
    });
    
    if (response.status === 401) {
      // Token expired or invalid
      localStorage.removeItem('token');
      localStorage.removeItem('userData');
      window.location.href = '/login';
      return;
    }
    
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    
    const data = await response.json();
    console.log(data);
    return data;
  } catch (error) {
    console.error('Error fetching users:', error);
    throw error;
  }
};

export const showBookings = async (clientId, calendarId) => {
  try {
    const token = getAuthToken();
    // console.log(`${REACT_APP_API_URL}/bookings/business/${clientId}`);
    const response = await fetch(`${REACT_APP_API_URL}/bookings/business/${clientId}/calendar/${calendarId}`, {
      method: 'GET',
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json'
      }
    });
    
    if (response.status === 401) {
      localStorage.removeItem('token');
      localStorage.removeItem('userData');
      window.location.href = '/login';
      return;
    }
    
    if (!response.ok) {
      let errorMsg = `Failed to fetch bookings: ${response.status}`;
      try {
        const errorData = await response.json();
        errorMsg = errorData.error || errorMsg;
      } catch {
        // If response isn't JSON, use default message
      }
      throw new Error(errorMsg);
    }
    
    const data = await response.json();
    
    if (data.success) {
      return data.data || [];
    } else {
      throw new Error(data.error || 'Failed to fetch bookings');
    }
  } catch (error) {
    console.error('Error fetching bookings:', error);
    throw error;
  }
};

export const sendChatMessage = async (callSid, message, clientId = null) => {
  try {
    const token = getAuthToken();
    
    const response = await fetch(`${REACT_APP_API_URL}/call/receive_text`, {
      method: 'POST',
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        CallSid: callSid,
        From: '',
        To: clientId,
        text: message,
        clientId: localStorage.getItem('currentclientId') // Get business ID from storage
      })
    });
    
    if (response.status === 401) {
      localStorage.removeItem('token');
      localStorage.removeItem('userData');
      window.location.href = '/login';
      return;
    }
    
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    
    const data = await response.json();
    return data;
  } catch (error) {
    console.error('Error sending chat message:', error);
    throw error;
  }
};

export const fetchBusinessContext = async (clientId) => {
  try {
    const token = getAuthToken();
    
    const response = await fetch(`${REACT_APP_API_URL}/context/${clientId}`, {
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json'
      }
    });
    
    if (response.status === 401) {
      localStorage.removeItem('token');
      localStorage.removeItem('userData');
      window.location.href = '/login';
      return;
    }
    
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    
    const data = await response.json();
    return data;
  } catch (error) {
    console.error('Error fetching business context:', error);
    throw error;
  }
};

export const updateBusinessContext = async (clientId, contextData) => {
  try {
    const token = getAuthToken();
    
    const response = await fetch(`${REACT_APP_API_URL}/context/${clientId}`, {
      method: 'PUT',
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(contextData)
    });
    
    if (response.status === 401) {
      localStorage.removeItem('token');
      localStorage.removeItem('userData');
      window.location.href = '/login';
      return;
    }
    
    if (!response.ok) {
      const errorData = await response.json().catch(() => ({}));
      throw new Error(errorData.message || `HTTP error! status: ${response.status}`);
    }
    
    const data = await response.json();
    return data;
  } catch (error) {
    console.error('Error updating business context:', error);
    throw error;
  }
};

export const createBusinessContext = async (contextData) => {
  try {
    const token = getAuthToken();
    
    const response = await fetch(`${REACT_APP_API_URL}/context`, {
      method: 'POST',
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(contextData)
    });
    
    if (response.status === 401) {
      localStorage.removeItem('token');
      localStorage.removeItem('userData');
      window.location.href = '/login';
      return;
    }
    
    if (!response.ok) {
      const errorData = await response.json().catch(() => ({}));
      throw new Error(errorData.message || `HTTP error! status: ${response.status}`);
    }
    
    const data = await response.json();
    return data;
  } catch (error) {
    console.error('Error creating business context:', error);
    throw error;
  }
};

export const fetchBusinessOrders = async (clientId) => {
  try {
    const token = getAuthToken(); // Assuming this is defined in your helper file
    
    // We point this to the new route: /orders/:businessId
    const response = await fetch(`${REACT_APP_API_URL}/orders/${clientId}`, {
      method: 'GET',
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json'
      }
    });
    
    // Consistent Session Management
    if (response.status === 401) {
      localStorage.removeItem('token');
      localStorage.removeItem('userData');
      window.location.href = '/login';
      return;
    }
    
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    
    const data = await response.json();
    
    // We return data.orders because our backend route wraps them in an object
    return data.orders || []; 
    
  } catch (error) {
    console.error('Error fetching business orders:', error);
    throw error;
  }
};

export const getComplaints = async (clientId) => {
  try {
    const response = await fetch(`${REACT_APP_API_URL}/business/complaints/${clientId}`);
    const result = await response.json();
    return result.success ? result.data : [];
  } catch (error) {
    console.error("Error fetching complaints:", error);
    return [];
  }
};

export const getCallbacks = async (clientId) => {
  try {
    const response = await fetch(`${REACT_APP_API_URL}/business/callbacks/${clientId}`);
    const result = await response.json();
    return result.success ? result.data : [];
  } catch (error) {
    console.error("Error fetching callbacks:", error);
    return [];
  }
};

// NEW: Accept a booking
export const acceptBooking = async (bookingId) => {
  try {
    const token = getAuthToken();
    
    const response = await fetch(`${REACT_APP_API_URL}/bookings/${bookingId}/accept`, {
      method: 'PUT',
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json'
      }
    });

    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(errorData.message || `Failed to accept booking: ${response.status}`);
    }

    return await response.json();
  } catch (error) {
    console.error('Error accepting booking:', error);
    throw error;
  }
};

// NEW: Cancel a booking
export const cancelBooking = async (bookingId, reason = '') => {
  try {
    const token = getAuthToken();
    
    const response = await fetch(`${REACT_APP_API_URL}/bookings/${bookingId}/cancel`, {
      method: 'PUT',
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({ reason })
    });

    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(errorData.message || `Failed to cancel booking: ${response.status}`);
    }

    return await response.json();
  } catch (error) {
    console.error('Error cancelling booking:', error);
    throw error;
  }
};

// NEW: Update booking status (general purpose)
export const updateBookingStatus = async (bookingId, status, additionalData = {}) => {
  try {
    const token = getAuthToken();
    
    const response = await fetch(`${REACT_APP_API_URL}/bookings/${bookingId}/status`, {
      method: 'PUT',
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({ 
        status,
        ...additionalData 
      })
    });

    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(errorData.message || `Failed to update booking status: ${response.status}`);
    }

    return await response.json();
  } catch (error) {
    console.error('Error updating booking status:', error);
    throw error;
  }
};


export const addMyNotes = async (bookingId, notes, userId) => {
  try {
    const token = getAuthToken();
    
    const response = await fetch(`${REACT_APP_API_URL}/bookings/mynote/${bookingId}`, {
      method: 'PUT',
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({ 
        notes,
        userId: userId
      })
    });

    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(errorData.message || `Failed to update booking status: ${response.status}`);
    }

    return await response.json();
  } catch (error) {
    console.error('Error updating booking status:', error);
    throw error;
  }
};





// NEW: Add reason input support (if you want to ask for cancellation reason)
export const cancelBookingWithReason = async (bookingId) => {
  return new Promise((resolve, reject) => {
    // This would be used with a custom modal that asks for cancellation reason
    // For now, we'll use a simple prompt or you can integrate with your modal
    const reason = window.prompt('Please provide a reason for cancellation (optional):', '');
    
    cancelBooking(bookingId, reason)
      .then(resolve)
      .catch(reject);
  });
};


// Mark order as ready
export const markOrderAsReady = async (orderId) => {
  try {
    const token = getAuthToken();
    
    const response = await fetch(
      `${REACT_APP_API_URL}/orders/${orderId}/ready`, 
      {
        method: 'PUT',
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        }
      }
    );

    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(errorData.error || `Failed to mark order as ready: ${response.status}`);
    }

    return await response.json();
  } catch (error) {
    console.error('Error marking order as ready:', error);
    throw error;
  }
};

// Cancel order
export const cancelOrder = async (orderId, reason = '') => {
  try {
    const token = getAuthToken();
    
    const response = await fetch(
      `${REACT_APP_API_URL}/orders/${orderId}/cancel`, 
      {
        method: 'PUT',
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({ reason })
      }
    );

    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(errorData.error || `Failed to cancel order: ${response.status}`);
    }

    return await response.json();
  } catch (error) {
    console.error('Error cancelling order:', error);
    throw error;
  }
};

// Mark order as delivered
export const markOrderAsDelivered = async (orderId) => {
  try {
    const token = getAuthToken();
    
    const response = await fetch(
      `${REACT_APP_API_URL}/orders/${orderId}/delivered`, 
      {
        method: 'PUT',
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        }
      }
    );

    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(errorData.error || `Failed to mark order as delivered: ${response.status}`);
    }

    return await response.json();
  } catch (error) {
    console.error('Error marking order as delivered:', error);
    throw error;
  }
};

// Update order status (general)
export const updateOrderStatus = async (orderId, status, reason = '') => {
  try {
    const token = getAuthToken();
    
    const response = await fetch(
      `${REACT_APP_API_URL}/orders/${orderId}/status`, 
      {
        method: 'PUT',
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({ status, reason })
      }
    );

    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(errorData.error || `Failed to update order status: ${response.status}`);
    }

    return await response.json();
  } catch (error) {
    console.error('Error updating order status:', error);
    throw error;
  }
};

// Get order details
export const getOrderDetails = async (orderId) => {
  try {
    const token = getAuthToken();
    
    const response = await fetch(
      `${REACT_APP_API_URL}/orders/${orderId}`, 
      {
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        }
      }
    );

    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(errorData.error || `Failed to fetch order details: ${response.status}`);
    }

    return await response.json();
  } catch (error) {
    console.error('Error fetching order details:', error);
    throw error;
  }
};

export const resolveComplaint = async (data) => {
  const token = localStorage.getItem('token'); // Retrieve your auth token
  
  const response = await fetch(`${REACT_APP_API_URL}/business/complaint-resolved`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${token}`
    },
    body: JSON.stringify(data),
  });

  const result = await response.json();
  
  if (!response.ok) {
    throw new Error(result.error || 'Failed to resolve complaint');
  }

  return result.data;
};

export const resolveCallback = async (data) => {
  const token = localStorage.getItem('token'); // Retrieve your auth token
  
  const response = await fetch(`${REACT_APP_API_URL}/business/callback-resolved`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${token}`
    },
    body: JSON.stringify(data),
  });

  const result = await response.json();
  
  if (!response.ok) {
    throw new Error(result.error || 'Failed to resolve complaint');
  }

  return result.data;
};

/**
 * Updates status or priority of a complaint.
 * @param {Object} data - { id: number, status?: string, priority?: string }
 */
export const setComplaintStatus = async (data) => {
  const token = localStorage.getItem('token');

  const response = await fetch(`${REACT_APP_API_URL}/business/complaint-set-status`, {
    method: 'PATCH',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${token}`
    },
    body: JSON.stringify(data),
  });

  const result = await response.json();

  if (!response.ok) {
    throw new Error(result.error || 'Failed to update complaint status');
  }

  return result.data;
};

export const setCallbackStatus = async (data) => {
  const token = localStorage.getItem('token');

  const response = await fetch(`${REACT_APP_API_URL}/business/callbackset-status`, {
    method: 'PATCH',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${token}`
    },
    body: JSON.stringify(data),
  });

  const result = await response.json();

  if (!response.ok) {
    throw new Error(result.error || 'Failed to update complaint status');
  }

  return result.data;
};

